
import styled from "@emotion/styled";
export const CarrouselContainer = styled.div`
display: flex;
flex-direction: row;
position: relative;
top: 45px;
z-index: 1;
.slick-list {
  display: flex;
}

.slick-slider {
  display: flex;
  height: 458px;
}

.slick-track {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  height: 438px;
  width: 1200px !important;

  @media (max-width: 768px) {
    left: 62%;
    transform: translateX(-50%);
  }
}
@media (max-width: 1500px) {
 .slick-list {
    margin: 0; /* Remove margin for smaller screens */
  }
  .slick-slider {
    left: 0; /* Align to the left */
    height: 400px;
  }
  
}
  @media (max-width: 768px) {
  top: 0;

  .slick-list {
    margin: 0; /* Remove margin for smaller screens */
  }
  .slick-slider {
    left: 0; /* Align to the left */
    height: 250px;
    margin-top: 30px;
  }
  
}
`;
export const ProductCarrouselContainer = styled.div`
display: flex;
flex-direction: row;
cursor: pointer;
overflow: hidden;
gap: 24px;
z-index: 1;

.slick-list {
  display: flex;
  margin: 0 300px;
}

.slick-slider {
  display: flex;
  height: 458px;
  left: 16px;
}

.slick-track {
  display: flex;
  gap: 24px;
  height: 438px;
  width: 1200px !important;
}
  // @media (max-width: 1500px) {
  // left: calc(45% - 50vw);
  // }

@media (max-width: 1200px) {
  left: 0;

  .slick-list {
    margin: 0; /* Remove margin for smaller screens */
  }
  .slick-slider {
    left: 0; /* Align to the left */
  }
}
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  width: 384px;
  height: 384px;
  border-width: 1px;
  border-style: solid;
  border-radius: 16px;
  background-color: #DAE753;
  border: 1px solid #DAE753;

    @media (max-width: 768px) {
      width: 251px;
      height: 251px;
    }
`;

export const StyledText = styled.span`
font-family: 'Roboto Condensed';
padding-top: 45px;
font-weight: 800;
font-size: 42px;
line-height: 49.22px;
letter-spacing: 0%;
margin-top: -30px;
color: #006437;
text-transform: uppercase;

@media (max-width: 768px) {
// margin-top: -30px;
font-size: 27.45px;
line-height: 32.17px;

}
`;

export const StyledImage = styled.img`
border-radius: 8px;
object-fit: contain;
width: 100%;
max-width: 294px;
height: 100%;
max-height: 248px;

@media (max-width: 768px) {
 max-width: 192px;
 max-height: 180px;
}
`;
